import API_BASE_URL from '../Config';

export const getTiposIngreso = async (token) => {
    const response = await fetch(`${API_BASE_URL}/tipos-ingreso`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tipos de ingreso');
    return response.json();
};

export const getTiposIngresoPaginados = async (token, page = 0, size = 10, search = '') => {
    const url = new URL(`${API_BASE_URL}/tipos-ingreso/page`);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    if (search) url.searchParams.append('search', search);

    const response = await fetch(url.toString(), {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar tipos de ingreso paginados');
    return response.json();
};

export const getTipoIngresoById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-ingreso/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al cargar el tipo de ingreso');
    return response.json();
};

export const createTipoIngreso = async (token, data) => {
    const response = await fetch(`${API_BASE_URL}/tipos-ingreso`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al crear el tipo de ingreso');
    return response.json();
};

export const updateTipoIngreso = async (token, id, data) => {
    const response = await fetch(`${API_BASE_URL}/tipos-ingreso/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Error al actualizar el tipo de ingreso');
    return response.json();
};

export const darDeBajaTipoIngreso = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-ingreso/${id}/dar-baja`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al dar de baja el tipo de ingreso');
};

export const deleteTipoIngreso = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/tipos-ingreso/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Error al eliminar el tipo de ingreso');
};
